/* eslint-disable default-case */
import React, { useState } from 'react';
import { TIPOS_DATO } from './fieldTypes';

// Nuevo componente para manejar las opciones de selección
const OpcionesSeleccion = ({ config, actualizarDefinicion }) => {
  const [nuevaOpcion, setNuevaOpcion] = useState('');
  const opciones = config.opciones || [];

  const agregarOpcion = () => {
    if (nuevaOpcion.trim() === '') return;
    const nuevasOpciones = [...opciones, nuevaOpcion.trim()];
    actualizarDefinicion({ ...config, opciones: nuevasOpciones });
    setNuevaOpcion('');
  };

  const eliminarOpcion = (index) => {
    const nuevasOpciones = [...opciones];
    nuevasOpciones.splice(index, 1);
    actualizarDefinicion({ ...config, opciones: nuevasOpciones });
  };

  return (
    <div>
      <label className="form-label">Opciones</label>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          value={nuevaOpcion}
          onChange={(e) => setNuevaOpcion(e.target.value)}
          placeholder="Añadir nueva opción"
        />
        <button className="btn btn-outline-secondary" type="button" onClick={agregarOpcion}>
          Agregar
        </button>
      </div>
      <ul className="list-group">
        {opciones.map((opcion, index) => (
          <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
            {opcion}
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => eliminarOpcion(index)}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};


export const renderConfiguracionPorTipo = (actualizarDefinicion, tipo, config) => {
    switch (tipo) {
      case TIPOS_DATO.NUMERICO:
        return (
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">Mínimo</label>
              <input
                type="number"
                className="form-control"
                value={config.minimo || 0}
                onChange={e => actualizarDefinicion({...config, minimo: Number(e.target.value)})}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Máximo</label>
              <input
                type="number"
                className="form-control"
                value={config.maximo || 100}
                onChange={e => actualizarDefinicion({...config, maximo: Number(e.target.value)})}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Unidad</label>
              <input
                type="text"
                className="form-control"
                value={config.unidad || ''}
                onChange={e => actualizarDefinicion({...config, unidad: e.target.value})}
              />
            </div>
          </div>
        );

      case TIPOS_DATO.SELECCION:
      case TIPOS_DATO.MULTIPLE:
        return (
          <div className="mb-3">
            <OpcionesSeleccion
              config={config}
              actualizarDefinicion={actualizarDefinicion}
            />
          </div>
        );

      case TIPOS_DATO.DURACION:
        return (
          <div className="mb-3">
            <label className="form-label">Unidad de Tiempo</label>
            <select
              className="form-select"
              value={config.unidadTiempo || 'dias'}
              onChange={e => actualizarDefinicion({...config, unidadTiempo: e.target.value})}
            >
              <option value="horas">Horas</option>
              <option value="dias">Días</option>
              <option value="semanas">Semanas</option>
            </select>
          </div>
        );

      case TIPOS_DATO.TEXTO:
        return (
          <div className="mb-3">
            <label className="form-label">Longitud Máxima</label>
            <input
              type="number"
              className="form-control"
              value={config.maxLength || 500}
              onChange={e => actualizarDefinicion({...config, maxLength: Number(e.target.value)})}
            />
          </div>
        );

      case TIPOS_DATO.COMPUESTO:
        return (
          <div className="mb-3">
            <label className="form-label">Subcampos</label>
            <div className="list-group">
              {(config.subcampos || []).map((subcampo, index) => (
                <div key={index} className="list-group-item">
                  <div className="row align-items-center">
                    <div className="col">
                      <input
                        type="text"
                        className="form-control"
                        value={subcampo.etiqueta}
                        onChange={e => {
                          const nuevosSubcampos = [...(config.subcampos || [])];
                          nuevosSubcampos[index] = {
                            ...subcampo,
                            etiqueta: e.target.value
                          };
                          actualizarDefinicion({ ...config, subcampos: nuevosSubcampos });
                        }}
                        placeholder="Etiqueta del subcampo"
                      />
                    </div>
                    <div className="col">
                      <select
                        className="form-select"
                        value={subcampo.tipo}
                        onChange={e => {
                          const nuevosSubcampos = [...(config.subcampos || [])];
                          nuevosSubcampos[index] = {
                            ...subcampo,
                            tipo: e.target.value
                          };
                          actualizarDefinicion({ ...config, subcampos: nuevosSubcampos });
                        }}
                      >
                        <option value="numerico">Numérico</option>
                        <option value="booleano">Si/No</option>
                        <option value="seleccion">Selección única</option>
                        <option value="multiple">Selección múltiple</option>
                        <option value="texto">Texto libre</option>
                        <option value="fecha">Fecha</option>
                        <option value="duracion">Duración</option>
                      </select>
                    </div>
                    <div className="col-auto">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => {
                          const nuevosSubcampos = [...(config.subcampos || [])];
                          nuevosSubcampos.splice(index, 1);
                          actualizarDefinicion({ ...config, subcampos: nuevosSubcampos });
                        }}
                      >
                        ×
                      </button>
                    </div>
                  </div>
                  {(subcampo.tipo === TIPOS_DATO.SELECCION || subcampo.tipo === TIPOS_DATO.MULTIPLE) && (
                    <div className="mt-2">
                      <OpcionesSeleccion
                        config={subcampo}
                        actualizarDefinicion={(nuevoSubcampo) => {
                          const nuevosSubcampos = [...(config.subcampos || [])];
                          nuevosSubcampos[index] = nuevoSubcampo;
                          actualizarDefinicion({ ...config, subcampos: nuevosSubcampos });
                        }}
                      />
                    </div>
                  )}
                  {subcampo.tipo === TIPOS_DATO.DURACION && (
                    <div className="mt-2">
                      <label className="form-label">Unidad de Tiempo</label>
                      <select
                        className="form-select"
                        value={subcampo.unidadTiempo || 'dias'}
                        onChange={e => {
                          const nuevosSubcampos = [...(config.subcampos || [])];
                          nuevosSubcampos[index] = { ...subcampo, unidadTiempo: e.target.value };
                          actualizarDefinicion({ ...config, subcampos: nuevosSubcampos });
                        }}
                      >
                        <option value="horas">Horas</option>
                        <option value="dias">Días</option>
                        <option value="semanas">Semanas</option>
                      </select>
                    </div>
                  )}
                </div>
              ))}
              <button
                type="button"
                className="btn btn-secondary mt-2"
                onClick={() => {
                  const nuevosSubcampos = [...(config.subcampos || []), {
                    etiqueta: '',
                    tipo: 'numerico'
                  }];
                  actualizarDefinicion({ ...config, subcampos: nuevosSubcampos });
                }}
              >
                Agregar subcampo
              </button>
            </div>
          </div>
        );
    }
  };